// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__3dYgq","range":"MonthRangeSwitch_range__3kvEV","disabled":"MonthRangeSwitch_disabled__cGA5Z"};